'use strict';

import {module} from '../app';

module.service('Account', [
    '$http', function ($http, authService) {
      return {
        login: function (portalUrl, username, password) {
          return $http.post(portalUrl + '/api/techpad-auth/login', { UserName: username, Password: password });
        },

        checkSessionValid: async function(portalUrl){
          return await $http.post(portalUrl + '/api/auth/CheckSessionValid');
        },

        setToken: function (token) {
          $http.defaults.headers.common.AuthToken = token;
        },

        registerDevice: function (portalUrl, deviceId) {
          $http.post(portalUrl + '/api/auth/registerDevice', { deviceId: deviceId });
        },

        unregisterDevice: function (portalUrl, deviceId) {
          $http.post(portalUrl + '/api/auth/unregisterDevice', { deviceId: deviceId });
        },

        getPortalSecurityToken: function (portalUrl) {
          return $http.get(portalUrl + '/api/techpadSecurity/generateToken');
        },

        changeTechnologistPassword: function (username, newPassword, portalUrl, authToken) {
          return $http.post(portalUrl + '/api-client/technologist', { email: username, newPassword }, {
            headers: { 'AuthToken': authToken }
          });
        },

        getPasswordRequirements: function (portalUrl) {
          return $http.get(portalUrl + '/api-client/technologist/getPasswordRequirements');
        }
      };
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/domains/account.js